"use client";
import SelfPickupForm from "@/components/SelfPickupForm/SelfPickupForm";
import React, { useState } from "react";
import "./PasswordPopup.css";

const PasswordPopup = ({ isOpen, onAuthenticate }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const correctPassword = "Bst@5566";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      onAuthenticate();
      setError("");
    } else {
      setError("Incorrect password. Please try again.");
      setPassword("");
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
    }
  };

  if (!isOpen) return null;

  return (
    <div className="b2b-popup-overlay" onClick={handleOverlayClick}>
      <div className="b2b-popup-container">
        <div className="b2b-popup-header">
          <h2 className="b2b-popup-title">Access Protected Page</h2>
          <p className="b2b-popup-subtitle">
            Please enter the password to continue
          </p>
        </div>

        <form className="b2b-popup-form" onSubmit={handleSubmit}>
          <div className="b2b-input-group">
            <input
              id="password"
              name="password"
              type="password"
              required
              className="b2b-password-input"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
          </div>

          {error && <div className="b2b-error-message">{error}</div>}

          <button type="submit" className="b2b-submit-button">
            Access Page
          </button>
        </form>
      </div>
    </div>
  );
};

const page = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showPopup, setShowPopup] = useState(true);

  const handleAuthenticate = () => {
    setIsAuthenticated(true);
    setShowPopup(false);
  };

  return (
    <>
      {!isAuthenticated && (
        <PasswordPopup isOpen={showPopup} onAuthenticate={handleAuthenticate} />
      )}

      <div className={!isAuthenticated ? "b2b-content-blurred" : ""}>
        <SelfPickupForm />
      </div>
    </>
  );
};

export default page;
